import { useEffect } from 'react'

import { TaxonomyType } from 'generated/graphql'
import { useWorkspaceCompanyPlan } from 'hooks/useWorkspaceCompanyPlan'

export const useIsGlobalTaxonomy = () => {
  const {
    workspaceTaxonomyType,
    getWorkspaceCompanyPlanFromApi,
    workspaceCompanyPlanLoading,
    workspaceCompanyPlanCalled,
  } = useWorkspaceCompanyPlan({
    errorLog: {
      from: 'modules/global-topic/common/hooks/use-is-global-taxonomy',
      name: 'Get workspace data',
      message: 'Obtain the workspace data',
    },
  })

  const isGlobalTaxonomyWorkspace = workspaceTaxonomyType === TaxonomyType.Country
  const isQueryInformationAvailable = workspaceCompanyPlanCalled && !workspaceCompanyPlanLoading

  useEffect(() => {
    getWorkspaceCompanyPlanFromApi()
  }, [getWorkspaceCompanyPlanFromApi])

  return {
    isGlobalTaxonomyWorkspace,
    isQueryInformationAvailable,
  }
}
